import $ from "jquery";
//import Stepper from "bs-stepper";
//let Functions = require('../functions');

export function initialize(){
    let $end_of_movie = $( "#end-of-movie-modal" );
    if($end_of_movie[0]) {
        console.log('EOM present');
        window.end_of_movie = {
            object: $end_of_movie,
            modal_options: {
                backdrop: 'static',
                keyboard: false
            }
        }
    } else {
        console.log('EOM missing');
    }
}